import { Selo, SeloRealizacao } from 'components/icons';
import { useEffect, useMemo, useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { TbMailFast } from 'react-icons/tb';
import { GetTaskLevelLabel } from 'utils/strings';
import { getMonthName } from 'services/utils';
import { object } from 'prop-types';
import { FormatNumber } from 'utils/helpers';
import { useAuth } from 'context/AuthContext';
import Tippy from '@tippyjs/react';
import { Divider } from 'rsuite';
import { faseDoItem } from './fase';
import CartaoDoExtrato from './CartaoDoExtrato';
import { tituloDaAcao } from './titulo-da-acao';

const CoinLabel: any = {
  uau: '#UAU',
  mandou: '#MANDOUBEM',
  valeu: '#VALEU',
};

const CHIP_EXTRA = 'inline-flex items-center gap-1.5 rounded-jj-pill bg-surface-app px-3 py-1 text-xs text-content';

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Protagonismo',
  lideranca: 'Liderança Integradora',
};

interface PointItemProps {
  data: any;
  cycleLabel?: string;
}

export function PointItem(props: PointItemProps) {
  const { data, cycleLabel } = props;
  const { realCycle } = useAuth();

  const behaviors = function (label?: string) {
    const _label = label || cycleLabel;

    return [
      {
        id: 'colaboracao',
        icon: <Selo size={'124px'} cycle={_label} selo="Colaboracao" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Colaboracao" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Colaboracao" />,
      },
      {
        id: 'foco',
        icon: <Selo size={'124px'} cycle={_label} selo="Foco" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Foco" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Foco" />,
      },
      {
        id: 'inovacao',
        icon: <Selo size={'124px'} cycle={_label} selo="Inovacao" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Inovacao" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Inovacao" />,
      },
      {
        id: 'resolutividade',
        icon: <Selo size={'124px'} cycle={_label} selo="Resolutividade" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Resolutividade" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Resolutividade" />,
      },
      {
        id: 'lideranca',
        icon: <Selo size={'124px'} cycle={_label} selo="Lideranca" />,
        smallIcon: <Selo size={'44px'} cycle={_label} selo="Lideranca" />,
        extraSmallIcon: <Selo size={'22px'} cycle={_label} selo="Lideranca" />,
      },
    ];
  };

  const galeria = [
    {
      id: 'galeria',
      icon: <Selo selo="Galeria" size={'124px'} cycle={cycleLabel} />,
    },
  ];

  const [origin, setOrigin] = useState<any>();
  const [taskOpened, setTaskOpened] = useState<boolean>(false);

  useEffect(() => {
    const defaultPoint = {
      type: 'default',
      title: 'Crédito de Pontos',
      total: data.total,
      time: data.time,
    };

    try {
      if (typeof data?.log === 'object' || (data?.log && data?.log.length)) {
        let log = typeof data?.log == 'object' ? data.log : data?.log[0];
        setOrigin({
          type: data.extra.type,
          extra: data.extra,
          log,
          total: data.total,
          time: data.time,
        });
      } else if (data.type) {
        setOrigin(data);
      } else {
        setOrigin(defaultPoint);
      }
    } catch (e) {
      setOrigin(defaultPoint);
    }
  }, [data]);

  function getIcon(key?: string, cycle?: string, extraSmall?: boolean) {
    if (!!key) {
      const icon = behaviors(cycle).filter(item => {
        return item.id === key;
      });

      if (extraSmall) {
        return icon[0].extraSmallIcon;
      }

      if (!!icon) {
        return icon[0].smallIcon;
      }
    }
  }

  // function translateTitle(item: any) {
  //   if (item?.log?.attributes?.campanha) {
  //     switch (item.log.attributes.campanha) {
  //       case 'agasalho_maio_2023':
  //         return 'Campanha do Agasalho 2023';
  //       case 'voluntariado_maio_2023':
  //         return 'Jogando Juntos no Voluntariado';
  //       default:
  //         return item.log.attributes.campanha;
  //     }
  //   }

  //   if (item?.log?.action === 'Entrou por convite') {
  //     return (
  //       <>
  //         <div className="flex flex-col">
  //           <span className="text-gray-3oo font-light text-sm leading-5">Convide seus amigos</span>
  //           <span className="text-gray-500 font-bold text-base leading-5 mt-3">
  //             Convite aceito por <span className="text-electric-blue capitalize">{item.extra.target_nome_guerra} </span>
  //             {`em ${format(new Date(item.time), 'dd MMM. yyyy')}.`}
  //           </span>
  //         </div>
  //       </>
  //     );
  //   }
  // }

  function tituloComMais(titulo: string) {
    return (
      <>
        {titulo}{' '}
        <button
          type="button"
          className="border-0 bg-transparent p-0 font-text text-sm font-normal text-brand-blue underline hover:no-underline"
          onClick={() => setTaskOpened(prevstate => !prevstate)}
        >
          {!taskOpened ? 'mais' : 'menos'}
        </button>
      </>
    );
  }

  function detalhesDaRealizacao(rotulo: string, texto: string) {
    return (
      <>
        <p className="m-0 mb-1 font-display font-bold">{rotulo}</p>
        <p
          className="m-0"
          dangerouslySetInnerHTML={{
            __html: texto.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;'),
          }}
        />
      </>
    );
  }

  return useMemo(() => {
    function renderSeloBB() {
      try {
        return (
          <CartaoDoExtrato
            etiqueta="Selo BB"
            titulo={`Recebeu o Selo BB em ${origin.log.attributes.selo}`}
            pontos={origin.total}
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderMoedasBonus() {
      try {
        return (
          <CartaoDoExtrato
            etiqueta="Campanha"
            titulo={`Você participou do ${origin.log.attributes.campanha}`}
            extras={
              <>
                <span className={CHIP_EXTRA}>{BehaviorLabel[origin.extra.behavior]}</span>
                <span className={CHIP_EXTRA}>+1 {CoinLabel[origin.extra.coin]}</span>
              </>
            }
            pontos={origin.total}
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderValoracaoGestor() {
      try {
        const contexto =
          origin.time >= 1741575600000 ? (
            <>
              Fase <b className="font-display capitalize text-brand-blue">{faseDoItem(origin)}</b> · Validação da Realização
              Destaque
            </>
          ) : origin.titlePoint ? (
            origin.titlePoint
          ) : (
            `Validação da Realização Destaque - ${origin.cicloTitle} - Fase ${getMonthName(origin.fase)}`
          );

        return (
          <CartaoDoExtrato
            dataEmCaixa={origin.time}
            contexto={contexto}
            titulo={origin.task ? tituloComMais(origin.task.title) : undefined}
            extras={
              origin.hasExpired ? (
                <Tippy
                  arrow={true}
                  allowHTML={true}
                  className="bg-black text-white font-thin rounded-xl p-2 tippy"
                  content={
                    <div>
                      <p>
                        IN 403-1:
                        <br />- <strong>6.4.9.2</strong> No caso de perda de prazo das etapas de validação e/ou das apreciações
                        níveis 1 e 2, conforme descrito no item <strong>7.4.6.5.4.8 Perda de Prazo</strong>, os líderes
                        responsáveis serão notificados da ocorrência.
                        <br />- <strong>6.4.9.2.1</strong> Em caso de reincidência, o líder não receberá a pontuação da fase que
                        perdeu o prazo.
                      </p>
                    </div>
                  }
                >
                  <span className={`${CHIP_EXTRA} text-brand-pink`} tabIndex={0}>
                    Pontuação não creditada conforme IN 403-1 item 6.4.9.2
                    <BiInfoCircle aria-hidden="true" />
                  </span>
                </Tippy>
              ) : undefined
            }
            pontos={origin.total}
            pontosEmBloco
            detalhes={
              taskOpened && typeof origin.task?.description === 'string'
                ? detalhesDaRealizacao('Detalhes da realização:', origin.task.description)
                : undefined
            }
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderValoracaoGestorFeedback() {
      try {
        return (
          <CartaoDoExtrato
            dataEmCaixa={origin.time}
            titulo={`Feedback enviado nas Realizações Destaque avaliadas - ${origin.cicloTitle} - Fase ${getMonthName(origin.fase)}`}
            pontos={origin.total}
            pontosEmBloco
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderBonusGestorColaboracao() {
      try {
        return (
          <CartaoDoExtrato
            dataEmCaixa={origin.time}
            titulo={`Bônus Colaboração (IN 403-1 item 7.2.6.5.3.15.10) - ${origin.cicloTitle} - Fase ${getMonthName(origin.fase)}`}
            pontos={origin.total}
            pontosEmBloco
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderBonusGestorPrazo() {
      try {
        return (
          <CartaoDoExtrato
            dataEmCaixa={origin.time}
            titulo={`Bônus por realizar as apreciações das realizações dentro do prazo - ${origin.cicloTitle} - Fase ${getMonthName(origin.fase)}`}
            pontos={origin.total}
            pontosEmBloco
          />
        );
      } catch (e) {
        return null;
      }
    }
    // function renderEntregaEquipe(isPlublic?: boolean) {
    //   try {
    //     return (
    //       <div className="flex flex-col bg-maastricht-blue-3 p-3 md:py-8 md:px-10 space-y-5 md:space-y-3 rounded-xl">
    //         <div className="flex-1 flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 md:items-center">
    //           {/* <div>
    //             {origin.status === 'aprovado' ? <RiThumbUpLine size={24} className="text-yellow" /> : null}
    //             {origin.status === 'dobrado' ? <BiCoinStack size={24} className="text-yellow" /> : null}
    //             {origin.status === 'promovido' ? <BiUpvote size={24} className="text-yellow" /> : null}
    //             {origin.status === 'selo' ? <BiTrophy size={24} className="text-yellow" /> : null}
    //           </div> */}
    //           {/* <div className="flex-1">
    //             <b>{origin.titulo}</b>
    //           </div> */}

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Nome da realização</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{origin.titulo}</p>
    //           </div>

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Fase</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{origin.faseTitle}</p>
    //           </div>

    //           <div className="flex-1 text-lg leading-none">
    //             <p className="font-thin text-sm text-gray-300">Status da entrega</p>
    //             <p className="font-bold text-base mt-1 text-gray-500">{GetTaskLevelLabel(origin.status)}</p>
    //           </div>

    //           <div className="text-base leading-none">
    //             <p className="font-thin text-sm mb-3 text-gray-300">{isPlublic ? 'Pontos da realização' : 'Atuação'}</p>

    //             <div className="flex">
    //               {origin?.participacao ? (
    //                 <b className="inline-flex flex-col items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none mr-3">
    //                   {origin.participacao}%
    //                   {/* <span className="block font-thin text-[10px] mt-1 uppercase leading-none">
    //                   Participação
    //                 </span> */}
    //                 </b>
    //               ) : null}

    //               {origin?.total ? (
    //                 <b className="flex flex-row items-center justify-center text-base bg-oxford-blue px-5 py-2 text-yellow rounded-full leading-none">
    //                   {FormatNumber(origin.total, false)}
    //                   <span className="font-thin text-[10px] mt-1 uppercase leading-none">pts</span>
    //                 </b>
    //               ) : null}
    //             </div>
    //           </div>
    //         </div>

    //         {typeof origin.descricao === 'string' && (
    //           <div>
    //             <p className="font-normal text-sm text-gray-300">Detalhes da realização:</p>
    //             <p
    //               className="font-bold text-base text-gray-500 m-1 "
    //               dangerouslySetInnerHTML={{
    //                 __html:
    //                   typeof origin.descricao === 'string'
    //                     ? origin.descricao.replace(/\n/gi, '<br>').replace(/\t/gi, '&nbsp;&nbsp;&nbsp;&nbsp;')
    //                     : '',
    //               }}
    //             />
    //           </div>
    //         )}
    //         {/* <div className="flex flex-row space-x-3 items-center justify-center">
    //           <div className="flex flex-row items-center space-x-2 px-2 text-white py-1 bg-purple rounded-full">
    //             <b>Participação: {origin.participacao}%</b>
    //           </div>
    //           <div className="flex flex-row items-center space-x-2 px-2 text-blue-dark py-1 bg-yellow rounded-full">
    //             <b>+{origin.total} pontos</b>
    //           </div>
    //         </div> */}
    //       </div>
    //     );
    //   } catch (e) {
    //     return null;
    //   }
    // }

    function renderEntregaEquipe(isPlublic?: boolean) {
      try {
        const contexto =
          origin.time >= 1741575600000 ? (
            <>
              Fase <b className="font-display capitalize text-brand-blue">{faseDoItem(origin)}</b> · Participação em Realização
              Destaque
            </>
          ) : origin.titlePoint ? (
            origin.titlePoint
          ) : (
            `Participação em Realização Destaque - ${origin.cicloTitle} - Fase ${faseDoItem(origin)}`
          );

        return (
          <CartaoDoExtrato
            dataEmCaixa={origin.time}
            contexto={contexto}
            titulo={origin.titulo ? tituloComMais(origin.titulo) : undefined}
            participacao={origin?.participacao}
            pontos={origin.total}
            pontosEmBloco
            detalhes={
              taskOpened && typeof origin.descricao === 'string'
                ? detalhesDaRealizacao('Detalhes da realização:', origin.descricao)
                : undefined
            }
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderEntregaEquipeEcoa(isPlublic?: boolean) {
      try {
        const fase =
          origin?.period === '3_semestral'
            ? realCycle?.find((e: any) => e.label === cycleLabel)?.steps.find(e => e.title === origin.faseTitle)?.semester_title
            : origin.faseTitle;

        return (
          <CartaoDoExtrato
            tom="lilas"
            data={origin.time}
            contexto={`Participação em Ação ECOA - ${origin.cicloTitle} - Fase ${fase}`}
            titulo={origin.titulo ? tituloComMais(origin.titulo) : undefined}
            pontos={origin.total}
            detalhes={
              taskOpened && typeof origin.descricao === 'string'
                ? detalhesDaRealizacao('Detalhes da ação:', origin.descricao)
                : undefined
            }
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderDestaqueCultura() {
      return (
        <div className="grid grid-cols-2 items-center gap-8 w-fit rounded-2xl">
          {behaviors()?.map(behavior => (
            <div
              className={`${data?.items?.find((item: any) => item.behavior === behavior.id) ? '' : 'opacity-20'}`}
              key={behavior.id}
            >
              <div>{behavior.icon}</div>
            </div>
          ))}
        </div>
      );
    }

    function renderDestaqueCulturaCondensed() {
      return (
        <div className="grid grid-cols-1 lg:grid-cols-3 items-center lg:gap-8 w-fit rounded-2xl">
          {origin.items
            .filter((item: any) => {
              return !!item.behavior;
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.behavior}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  {getIcon(item.behavior, item?.cycle, true)}
                </div>
                <div className="flex flex-col justify-center">
                  {/* <span className="text-grey-dark text-sm lg:text-xs font-medium mb-1">
                    {origin.items[index]?.position}
                  </span> */}
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">
                    {BehaviorLabel[item.behavior]}
                  </h4>
                </div>
              </div>
            ))}

          {origin.items
            .filter((item: any) => {
              return !item.behavior && !item.type;
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.behavior + item._id}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  <Selo selo="Galeria" size={22} cycle={cycleLabel ? cycleLabel : item.cycle} />
                </div>
                <div className="flex flex-col justify-center">
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">Galeria do reconhecimento</h4>
                </div>
              </div>
            ))}

          {origin.items
            .filter((item: any) => {
              return item.type === 'realizacao';
            })
            .map((item: any) => (
              <div className="flex flex-row" key={item.realizacao + item._id}>
                <div className="icon bg-maastricht-blue p-1 h-[30px] w-[30px] mr-1 block rounded-md">
                  <Selo selo="Realizacao" size={22} cycle={cycleLabel ? cycleLabel : item.cycle} />
                </div>
                <div className="flex flex-col justify-center">
                  <h4 className="text-[#5E7A90] lg:text-[10px] text-base font-normal leading-3">Realização Destaque</h4>
                </div>
              </div>
            ))}
        </div>
      );
    }

    function renderDestaqueCulturaIcon() {
      return (
        <div className="bg-[#022138] w-[60px] h-[60px] rounded-[3px] flex justify-center items-center">
          {origin.behavior ? (
            getIcon(origin.behavior, origin?.cycle)
          ) : origin.typeItem ? (
            <Selo selo="Realizacao" size={44} cycle={origin.cycle} />
          ) : (
            <Selo selo="Galeria" size={44} cycle={origin.cycle} />
          )}
        </div>
      );
    }

    function renderGaleria() {
      return (
        <div className="flex items-center space-x-8 w-fit rounded-2xl">
          {galeria.map(galeria => (
            <div className={`${!!data ? '' : 'opacity-20'}`} key={galeria.id}>
              <div>{galeria.icon}</div>
            </div>
          ))}
        </div>
      );
    }
    function renderSeloRealizacaoDestaque() {
      return (
        <div className="flex items-center space-x-8 w-fit rounded-2xl">
          <div className={`${!!data ? '' : 'opacity-20'}`}>
            <div>
              <SeloRealizacao selo="Realizacao" size={'124px'} cycle={cycleLabel} />
            </div>
          </div>
        </div>
      );
    }

    // Selo de Realização Destaque, no cartão das telas migradas (o detalhe do perfil em Destaques).
    function renderSeloRealizacao() {
      try {
        return (
          <CartaoDoExtrato
            etiqueta="Selo conquistado"
            titulo={origin.titulo}
            extras={
              <span aria-hidden="true">
                <Selo selo="Realizacao" size={56} cycle={cycleLabel} />
              </span>
            }
            pontos={origin?.total ? origin.total : undefined}
            pontosEmBloco
            detalhes={
              typeof origin.descricao === 'string' ? detalhesDaRealizacao('Detalhes da realização:', origin.descricao) : undefined
            }
          />
        );
      } catch (e) {
        return null;
      }
    }

    function renderRealizacaoColetiva() {
      try {
        return (
          <CartaoDoExtrato
            contexto={[origin.fase && `Fase ${origin.fase}`, origin.status && `Status da entrega: ${origin.status}`]
              .filter(Boolean)
              .join(' · ')}
            titulo={origin.title}
            pontos={origin.total ?? 0}
            pontosEmBloco
            detalhes={
              typeof origin.description === 'string'
                ? detalhesDaRealizacao('Detalhes da realização:', origin.description)
                : undefined
            }
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderRealizacaoPremiada() {
      try {
        const descricao = typeof origin?.task?.description === 'string' ? origin.task.description : origin.descricao;

        return (
          <CartaoDoExtrato
            titulo={origin?.task?.title ? origin.task.title : origin.titulo}
            pontos={origin.total ?? 0}
            pontosEmBloco
            detalhes={typeof descricao === 'string' ? detalhesDaRealizacao('Detalhes da realização:', descricao) : undefined}
          />
        );
      } catch (e) {
        return null;
      }
    }
    function renderCampanhaBonus() {
      try {
        const { etiqueta, titulo } = tituloDaAcao(origin, cycleLabel);

        return <CartaoDoExtrato etiqueta={etiqueta} titulo={titulo} pontos={origin.total} />;
      } catch (e) {
        return null;
      }
    }
    function renderQuizBonus() {
      try {
        return <CartaoDoExtrato etiqueta="Responder ao quiz" titulo={origin?.log?.action} pontos={origin.total} />;
      } catch (e) {
        return null;
      }
    }
    function renderDefault() {
      const { etiqueta, titulo } = tituloDaAcao(origin, cycleLabel);
      const ideia = origin?.log?.attributes;

      return (
        <CartaoDoExtrato
          etiqueta={etiqueta}
          titulo={titulo}
          extras={
            ideia?.tag || ideia?.role ? (
              <span className={CHIP_EXTRA}>
                {ideia?.description} #{ideia?.number} {ideia?.tag ? '#' + ideia.tag : ''}
              </span>
            ) : undefined
          }
          pontos={origin.total}
          detalhes={
            ideia?.tag && taskOpened ? (
              <>
                <p className="m-0 mb-1 font-display font-bold">Detalhes da ideia:</p>
                <p className="m-0">
                  Número: {ideia?.number} | Tag: {ideia?.tag}
                </p>
                <p className="m-0 mt-1">Título: {ideia?.description}</p>
              </>
            ) : undefined
          }
        />
      );
    }
    if (!origin) return null;

    if (origin.type === 'actions' && origin.extra.origin === 'quiz_natal2025') {
      return renderQuizBonus();
    }

    switch (origin.type) {
      case 'moedas_bonus':
        return renderMoedasBonus();
      case 'selobb':
        return renderSeloBB();
      case 'destaque_cultura':
        return renderDestaqueCultura();
      case 'destaque_cultura_condensed':
        return renderDestaqueCulturaCondensed();
      case 'destaque_cultura_icon':
        return renderDestaqueCulturaIcon();
      case 'entrega_equipe':
        return renderEntregaEquipe();
      case 'entrega_equipe_ecoa':
        return renderEntregaEquipeEcoa();
      case 'entrega_equipe_public':
        return renderEntregaEquipe(true);
      case 'entrega_gestor':
        return renderValoracaoGestor();
      case 'feedback_gestor':
        return renderValoracaoGestorFeedback();
      case 'bonus_colaboracao_gestor':
        return renderBonusGestorColaboracao();
      case 'pontos_bonus_prazo_gestor':
        return renderBonusGestorPrazo();
      case 'galeria':
        return renderGaleria();
      case 'selo_realizacao_destaque':
        return renderSeloRealizacaoDestaque();
      case 'selo_realizacao':
        return renderSeloRealizacao();
      case 'realizaca_premiada_coletiva':
        return renderRealizacaoColetiva();
      case 'realizaca_premiada':
        return renderRealizacaoPremiada();
      case 'campaign_bonus':
        return renderCampanhaBonus();
      default:
        return renderDefault();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [origin, taskOpened, behaviors, data, cycleLabel, galeria]);
}
